import Frbypasslinks from 'fr-bypasslinks'

/* eslint-disable no-unused-vars */

import stylesheet from 'fr-bypasslinks/bypasslinks.css'

/* eslint-enable */

const bypassLinks = Frbypasslinks({
  selector: '.js-fr-bypasslinks'
})

export default { bypassLinks, Frbypasslinks }



/** WEBPACK FOOTER **
 ** ./src/modules/skiplinks/index.js
 **/